import React from "react";
import { Link } from "react-router-dom";

import "./styles/footer.css";

const Footer = () => {
  const date = new Date();
  return (
    <>
      <div className="footer">
        <div className="footer-links">
          <ul className="footer-nav-link-list">
            <li className="footer-nav-link-item">
              <Link to="/">Home</Link>
            </li>
            <li className="footer-nav-link-item">
              <Link to="/projects">Projects</Link>
            </li>
            <li className="footer-nav-link-item">
              <Link to="/about">About</Link>
            </li>
            <li className="footer-nav-link-item">
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        <div className="footer-credits">
          <p className="footer-credits-text">
            Crafted using ReactJs and turbocharged by Parcel
          </p>
          <p className="footer-credits-text">
            © {date.getFullYear()} Akash Dandriyal
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
